'use client'

import { useIntersectionObserver } from '@/hooks/useIntersectionObserver'

import styles from './iframe-map.module.css'

type IframeMapProps = {
  url: string,
  title: string
}

export const IframeMap = ({url, title, ...props}: IframeMapProps) => {
  // loading="lazy" ne suffit pas : en connexion lente Chrome charge l'embed Maps dès le début de page
  const { ref, isIntersecting } = useIntersectionObserver({ rootMargin: '300px', freezeOnceVisible: true })

  return (
    <iframe
      ref={ref}
      title="L'agence sur la carte"
      className={styles.map}
      src={isIntersecting ? url : undefined}
      width="472"
      height="150"
      allowFullScreen={false}
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      {...props}
      />
  )
}
